module.exports = __webpack_public_path__ + "media/newstyle/images/chevron-right-black-b4e3714b074251316d9d69baa1e5f371.svg";